/* Essential Cart preserva properties ao trocar a variante de uma linha.
 * Em produtos com pré-venda, a nova combinação deve passar pela PDP para
 * receber o aviso/propriedade corretos. Snapshots vencidos são removidos do
 * carrinho para não reaparecerem no checkout ou no pedido.
 */
(() => {
  const selector = '[data-essential-cart-element="line-item-variant-selector"] select';
  let cleanupInFlight = false;
  const cleanupAttempts = new Set();

  async function cleanupExpiredSnapshots() {
    if (cleanupInFlight) return;
    const lineKeys = [...new Set(
      [...document.querySelectorAll('[data-ohli-preorder-expired][data-line-key]')]
        .map((marker) => marker.dataset.lineKey)
        .filter(Boolean)
    )].sort();
    const signature = lineKeys.join(',');
    if (!signature || cleanupAttempts.has(signature)) return;
    cleanupAttempts.add(signature);
    cleanupInFlight = true;
    try {
      let cart = await fetch(`${routes.cart_url}.js`).then((response) => {
        if (!response.ok) throw new Error('Não foi possível ler o carrinho.');
        return response.json();
      });
      for (const lineKey of lineKeys) {
        const item = cart.items.find((cartItem) => cartItem.key === lineKey);
        if (!item?.properties?.['Pré-venda']) continue;
        const properties = { ...item.properties };
        const expiredSnapshot = properties['Pré-venda'];
        delete properties['Pré-venda'];
        properties['_Pré-venda encerrada'] = expiredSnapshot;
        const response = await fetch(routes.cart_change_url, {
          ...fetchConfig(),
          body: JSON.stringify({ id: item.key, properties }),
        });
        if (!response.ok) throw new Error('Não foi possível atualizar o carrinho.');
        cart = await response.json();
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ohli-preorder-expiry', cartData: cart });
    } catch (error) {
      console.error('[Ohli] Falha ao remover aviso de pré-venda vencido.', error);
    } finally {
      cleanupInFlight = false;
    }
  }

  function productsByVariant() {
    const variants = new Map();
    document.querySelectorAll('[data-ohli-preorder-product]').forEach((marker) => {
      marker.dataset.variantIds.split(',').forEach((id) => variants.set(id, marker.dataset.productUrl));
    });
    return variants;
  }
  function productFor(select, variants) {
    for (const option of select.options) {
      if (variants.has(option.value)) return variants.get(option.value);
    }
    return null;
  }
  function protectSelectors() {
    document.querySelectorAll('[data-essential-cart-element="line-item-properties"] > div').forEach((property) => {
      property.toggleAttribute('data-ohli-preorder-note', property.textContent.trim().startsWith('Pré-venda:'));
    });
    const variants = productsByVariant();
    document.querySelectorAll(selector).forEach((select) => {
      const productUrl = productFor(select, variants);
      if (!productUrl) return;
      if (!select.disabled) select.disabled = true;
      select.dataset.ohliPreorderVariant = select.value;
      const wrapper = select.closest('[data-essential-cart-element="cart-drawer-item-details"]');
      if (!wrapper) return;
      if (wrapper.querySelector('[data-ohli-preorder-guidance]')) return;
      const note = document.createElement('p');
      note.className = 'product-option';
      note.dataset.ohliPreorderGuidance = '';
      note.append('Para trocar, remova este item e ');
      const link = document.createElement('a');
      link.className = 'link link--text';
      link.href = productUrl;
      link.textContent = 'escolha no produto';
      note.append(link, '.');
      wrapper.append(note);
    });
  }
  // Capture impede que uma interação no intervalo anterior ao observer chegue
  // ao app com a propriedade de outra variante.
  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!select.matches?.(selector) || !productFor(select, productsByVariant())) return;
    event.stopImmediatePropagation();
    if (select.dataset.ohliPreorderVariant) select.value = select.dataset.ohliPreorderVariant;
    protectSelectors();
  }, true);
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      protectSelectors();
      cleanupExpiredSnapshots();
    });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  protectSelectors();
  cleanupExpiredSnapshots();
})();
